import { motion } from "framer-motion";

export const LineMask = ({ children, delay = 0, duration = 0.9, className = "" }) => {
    return (
        <span className={`line-mask ${className}`}>
            <motion.span
                style={{ display: "inline-block", willChange: "transform" }}
                initial={{ y: "110%" }}
                animate={{ y: "0%" }}
                transition={{ delay, duration, ease: [0.2, 0.9, 0.2, 1] }}
            >
                {children}
            </motion.span>
        </span>
    );
};

export const RevealOnScroll = ({ children, delay = 0, y = 40, className = "" }) => {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ delay, duration: 0.9, ease: [0.2, 0.9, 0.2, 1] }}
        >
            {children}
        </motion.div>
    );
};
